import { useNavigate } from "react-router-dom";
import Card from "#/components/shared/card";
import ThemedSpinner from "#/components/shared/spinner";
import Typography from "#/components/shared/typography";
import { SubmitButton } from "#/components/shared/buttons/submit-button";
import { MedicalRecordsRequestsSection } from "#/medical-records-requests/components/MedicalRecordsRequestsSection";
import { useUserDetails } from "#/hooks/useUserDetails";

export default function MedicalRecordsRequestsPage() {
  const { userDetails, isLoading, error } = useUserDetails();
  const navigate = useNavigate();
  const isAdmin = userDetails?.type === "admin";

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-16">
        <div className="flex justify-center">
          <ThemedSpinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-16">
        <Card variant="cream" elevation={1}>
          <Card.Body className="space-y-2">
            <Typography variant="h4" className="text-terracotta">
              Unable to load your account
            </Typography>
            <Typography variant="body2" className="text-brown-700">
              {error instanceof Error ? error.message : "Please try again later."}
            </Typography>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (!userDetails?.id) {
    return (
      <div className="container mx-auto px-4 py-16">
        <Typography variant="body1" className="text-brown-700">
          We couldn’t verify your profile.
        </Typography>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-10">
      {isAdmin && (
        <div className="mb-6 flex justify-end">
          <SubmitButton
            color="beige"
            onClick={() => navigate("/medical-records/requests/all")}
          >
            View all requests
          </SubmitButton>
        </div>
      )}
      <MedicalRecordsRequestsSection userId={userDetails.id} />
    </div>
  );
}
